import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Apollo } from 'apollo-angular'
import gql from 'graphql-tag'
import { centsToCurrencyString } from 'src/logic/pricing'
import { paramsErrorToast } from 'src/toaster'

const purchaseExtra = gql`
  mutation purchaseExtra($customerId: ID!, $options: [String]!) {
    purchaseExtra(customerId: $customerId, options: $options) {
      id
      purchasedAt
      extra {
        id
        code
      }
    }
  }
`

@Component({
  selector: 'ten-topics-purchase-modal',
  template: `
    <div *ngIf="!tenTopicsPurchaseSuccessful">
      <h4 class="small-top-buffer">10 Blog Topic Ideas</h4>
      <hr class="brand-hr"/>
      <p class="h4-subheader">
        Fresh eyes = fresh ideas, fast. One of our HubSpot Inbound-certified experts will deliver you
        <b>10 ideas</b> within <b>2 business days</b> for <b>only {{priceAndDiscountMessage}}</b>.
      </p>
      <p class="h4-subheader">
        Use the topics you like as-is, or make changes before requesting content from our writers.
      </p>
      <button class="btn btn-primary mr-2" (click)="onBuyTopics()" [disabled]="loadingPurchase">{{loadingPurchase? 'loading...':'Get 10 Topics'}}</button>
      <button class="btn btn-outline-primary" (click)="closeModal()">Not now</button>
      <p class="small-text small-top-buffer">You will be charged {{prettyPrice}} as a one-time payment.</p>
    </div>
    <div *ngIf="tenTopicsPurchaseSuccessful">
      <i class="d-block far fa-check-circle icon-lg text-success"></i>
      <h4 class="small-top-buffer">
      HAVE SPECIFIC PREFERENCES?
      </h4>
      <hr class="brand-hr"/>
      <p class="h3-subheader">
        Our team is now ready to research, write, and deliver your 10 Topic ideas!
      </p>
      <p class="h3-subheader">
        If you want to give our experts any specific brand or content direction before they start brainstorming,
        <b>please complete the following Google survey within 3 hours of your order.</b>
      </p>
      <p class="h3-subheader mb-4">
        <b>If we don’t hear from you in that timeframe, your survey may not be considered.</b>
        Instead, we’ll expertly use the info from your account & website for inspiration.
      </p>
      <button class="btn btn-secondary mr-2" (click)="onGoToForm()">Take me to the survey!</button>
      <button class="btn btn-outline-secondary" (click)="closeModal()">I trust your research</button>
    </div>
  `
})
export class TenTopicsPurchaseModal {
  loadingPurchase: boolean = false
  tenTopicsPurchaseSuccessful = false
  purchaseExtra: any

  constructor(
    public dialogRef: MatDialogRef<TenTopicsPurchaseModal>,
    @Inject(MAT_DIALOG_DATA) public data,
    private apollo: Apollo,
  ) {}

  onGoToForm(): void {
    this.closeModal()
    window.open("https://goo.gl/forms/AcTPDHDc0qstXxFq1", "_blank")
  }

  closeModal(): void {
    this.dialogRef.close({ data: this.purchaseExtra })
  }

  get priceAndDiscountMessage(): string {
    let message : string = this.prettyPrice
    if (this.data.price != this.data.priceDefault) {
      const priceOff : number = 100 * (1 - this.data.price / this.data.priceDefault)
      message += ` (that's ${Math.round(priceOff)}% off)`
    }
    return message
  }

  get prettyPrice(): string {
    return centsToCurrencyString(this.data.price, { truncateZeroCents: true })
  }

  onBuyTopics(): void {
    this.loadingPurchase = true
    this.apollo.mutate({
      mutation: purchaseExtra,
      variables: {
        customerId: this.data.customerId,
        options: ['ten_topics']
      }
    }).subscribe(( { data }: any) => {
      this.loadingPurchase = false
      this.tenTopicsPurchaseSuccessful = true
      this.purchaseExtra = data.purchaseExtra
    }, (error) => {
      this.loadingPurchase = false
      if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        error.graphQLErrors.map(({ message }) => paramsErrorToast(message))
      }
    })
  }
}
